import { render, staticRenderFns } from "./FinalLineup.vue?vue&type=template&id=52e51cfd&scoped=true"
import script from "./FinalLineup.vue?vue&type=script&lang=js"
export * from "./FinalLineup.vue?vue&type=script&lang=js"
import style0 from "./FinalLineup.vue?vue&type=style&index=0&id=52e51cfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e51cfd",
  null
  
)

export default component.exports